import { useMemo, useRef, useState } from "react";
import { deletetag } from "../../../utils/CommonFunc";

interface IProps {
  data: string;
  className: string;
  admin: any;
  type?: string;
}

function ContentsTags(props: IProps) {
  const { data, className, admin, type } = props;
  const [isMore, setIsMore] = useState(false);
  const textLimit = useRef<number>(500);

  const dataLen: number | undefined = deletetag(data, [])?.length;

  const contents = useMemo(() => {
    const shortReview: string | undefined = deletetag(data, [
      "img",
      "br",
      "div"
    ])?.slice(0, textLimit.current);

    if (dataLen === undefined ? 0 : dataLen > textLimit.current) {
      if (isMore) {
        return deletetag(data, ["img", "br", "div"]);
      }
      return shortReview;
    }
    return deletetag(data, ["img", "br", "div"]);
  }, [isMore]);

  return admin === 1 ? (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: data as string
      }}
    />
  ) : false ? (
    <>
      <div
        className={className}
        dangerouslySetInnerHTML={{
          __html: contents as string
        }}
      />
      {/* <div onClick={() => setIsMore((prev) => !prev)}>
        {dataLen === undefined ? 0 : dataLen > textLimit.current && (isMore ? "[닫기]" : "...[더보기]")}
      </div> */}
    </>
  ) : (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: deletetag(data, ["img", "br", "div"]) as string
      }}
    />
  );
}

export default ContentsTags;
